export const SAVE_HISTORY = 'schedule/SAVE_HISTORY';